import SEOMetadata from "../../components/SEOMetadata";
import { seoConfig } from "../../config/seoConfig";
import AllModelsBennar from "../../components/allModels/allModelsBennar";
import Models from "../../components/allModels/models";
import usePageTitle from "../../hooks/usePageTitle";

const AllModels = () => {
  usePageTitle("Utility Vehicles");
  const seoData = seoConfig.us.utilityVehicles;

  return (
    <>
      <SEOMetadata
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
      />
      <AllModelsBennar />
      <Models />
    </>
  );
};
export default AllModels;
